import React, { useContext } from 'react';
import { MapContext, withMap, LayerFeatures } from '@robinpowered/atlas-web';
import { withLayers, MapboxFeature } from '@robinpowered/atlas-common';
import { NeighborhoodsContext } from './NeighborhoodsContext';
import { NeighborhoodPopup } from './NeighborhoodPopup';
import { useNeighborhoodMapInteractions } from './useNeighborhoodMapInteractions';

interface NeighborhoodProps {
  map: MapContext;
  seatFeatures: MapboxFeature[];
}
const NeighborhoodsOverlay = withMap(
  ({ map, seatFeatures }: NeighborhoodProps): JSX.Element | null => {
    const { neighborhoods, showColor } = useContext(NeighborhoodsContext);
    const neighborhoodMapInteractions = useNeighborhoodMapInteractions(
      map,
      seatFeatures,
      neighborhoods
    );

    return (
      <>
        {neighborhoods.map((neighborhood) => (
          <NeighborhoodPopup
            key={`${neighborhood.id}`}
            neighborhood={neighborhood}
            centroid={neighborhoodMapInteractions.getNeighborhoodCentroid(
              neighborhood
            )}
            showColor={showColor}
          />
        ))}
      </>
    );
  }
);

export const Neighborhoods = withMap(
  withLayers('seats')((sources) => (
    <LayerFeatures specifier={sources.layers}>
      {({ features }: { features: MapboxFeature[] }) => (
        <NeighborhoodsOverlay seatFeatures={features} />
      )}
    </LayerFeatures>
  ))
);
